import qs from 'qs';

import { serviceApi } from '~/api';

const messageUrl = (pageId) => `messages/${pageId}`;

const getPageMessages = (pageId, shopId) =>
  serviceApi.fetchJSON(
    `${messageUrl(pageId)}${qs.stringify({ shopId }, { addQueryPrefix: true, skipNulls: true })}`,
  );

export const messagesApi = {
  getPageMessages,
};
